import {AfterViewInit, Component, HostListener, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {KonvasComponent} from "../../component/konvas/konvas.component";
import {
  forkJoin,
  from,
  interval,
  map,
  mergeMap,
  Observable,
  retry,
  Subject,
  Subscription,
  take,
  takeUntil,
  tap
} from "rxjs";
import {DOCUMENT, NgForOf, NgIf} from "@angular/common";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {faCameraRotate} from "@fortawesome/free-solid-svg-icons";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {DomSanitizer} from "@angular/platform-browser";
import {CommonComponent} from "../../common/common-component";
import {ConfigService} from "../../common/service/config.service";
import {ContentBlockComponent} from "../../component/content-block/content-block.component";
import {ReCaptchaV3Service} from "ng-recaptcha";

export const BreakError = {};
export enum Lifecycle {
  INIT,
  CAPTURING,
  CAPTURING_TRIGGERED,
  CAPTURED,
  CAPTURED_PROCESSING,
  CAPTURED_UPLOADING,
  COMPLETED,
  ERROR,
}

@Component({
  selector: 'section#capture.w-100',
  standalone: true,
    imports: [
        KonvasComponent,
        NgIf,
        FaIconComponent,
        NgForOf,
        RouterLink,
        ContentBlockComponent
    ],
  templateUrl: './capture.component.html'
})
export class CaptureComponent extends CommonComponent implements OnInit, AfterViewInit, OnDestroy {

  protected readonly faCameraRotate = faCameraRotate;
  protected readonly Lifecycle = Lifecycle;

  protected subscription: Subscription | undefined;

  @ViewChild(KonvasComponent) canvas!: KonvasComponent;

  public videoContainer: HTMLVideoElement | undefined;
  public videoAllowed = true;
  public counter: number = 0;
  public images: Array<Blob> = [];
  public state: Lifecycle = Lifecycle.INIT;
  public previewScreen: boolean = false;
  public boothMode: boolean = false;
  public captchaFailed: boolean = false;
  public serverError: boolean = false;


  protected currentCamera: number | undefined;
  protected devices: MediaDeviceInfo[] | undefined;
  protected filenames: Array<any> = [];
  public rotate: number = 0;

  protected path: string | undefined;
  private destroyed$ = new Subject<void>;

  constructor(
    protected httpClient: HttpClient,
    protected router: Router,
    protected route: ActivatedRoute,
    protected sanitizer: DomSanitizer,
    protected configService: ConfigService,
    protected reCaptchaV3Service: ReCaptchaV3Service,
    @Inject('Storage') protected storage: Storage,
    @Inject(DOCUMENT) protected document: Document
  ) {
    super();
    this.boothMode = this.storage.getItem('forceBoothMode') === 'true';
    this.route.url.subscribe((url) => {
      // console.log(url);
      this.path = url[0].path;
    });
  }

  ngOnInit(): void {

    const rotation = this.storage.getItem('rotation');

    if(rotation) {
      this.rotate = parseInt(rotation, 10);
    }

    this.subscription = this.configService.config$.subscribe((config) => {
      this.config = config;
      const user_config = JSON.parse(this.storage.getItem('user_config') || '{}');

      // this.route
      if(this.config.enableSelection) {
        const imageBlock = Object.values(this.config.contentBlocks).find((block: any) => block.type === 'image');
        // @ts-ignore
        const blockConfig = JSON.parse(imageBlock?.content || '{}');
        // console.log('imageBlock', imageBlock, blockConfig);
        if ( ! user_config.hasOwnProperty(blockConfig?.key) || user_config[blockConfig?.key] == '') {
          // force user_config first, so it does not break the flow
          this.router.navigate(['../choose'], {relativeTo: this.route}).then();
        }
      }

      if(this.config.enableSurvey) {
        if ( ! user_config.hasOwnProperty('<!--(survey)--!>') || user_config['<!--(survey)--!>'].length < 1) {
          // force user_config first, so it does not break the flow
          this.router.navigate(['../survey'], { relativeTo: this.route }).then();
        }
      }

      if(this.config.enableGenerationSelection) {
        if ( ! user_config.hasOwnProperty('<!--(generations)--!>') || user_config['<!--(generations)--!>'].length < 1) {
          // force user_config first, so it does not break the flow
          this.router.navigate(['../themes'], { relativeTo: this.route }).then();
        }
      }

      if( ! this.config.enableAi) {
        this.router.navigate(['../disabled'], { relativeTo: this.route }).then();
      }

    });
  }

  ngAfterViewInit(): void {
    console.log('CaptureComponent::ngAfterViewInit');
    from(navigator.mediaDevices.enumerateDevices()).pipe(
      takeUntil(this.destroyed$)
    ).subscribe({
      next: (devices: MediaDeviceInfo[]) => {
        this.devices = devices.filter((device: MediaDeviceInfo) => device.kind === 'videoinput');
        // console.log(this.devices);
        setTimeout(() => {
          this.startVideo();
        }, 1000);
      },
      error: (error) => {
        console.error('Error accessing media devices.', error);
        this.videoAllowed = false;
      }
    });
  }


  ngOnDestroy(): void {
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
    this.destroyed$.next();
    this.destroyed$.complete();
  }


  @HostListener('document:keydown.control.k')
  changeCamera($event: Event) {

    // console.log('ctrl k')

    if (this.videoContainer && this.devices && this.devices?.length > 1) {

      // @ts-ignore
      // console.log(this.videoContainer.srcObject.getTracks());
      // @ts-ignore
      // console.log(this.videoContainer.srcObject.getTracks()[0].getCapabilities());

      // console.log(this.devices);

      // @ts-ignore
      const currentDeviceId = this.videoContainer.srcObject.getTracks()[0].getCapabilities().deviceId;

      this.stopVideo();
      // this.state = 'loading';

      // console.log('hello?', this.devices?.length, this.currentCamera);

      if (this.devices?.length) {

        if (this.currentCamera == (this.devices?.length - 1)) {
          this.currentCamera = 0;
          // console.log('setting 000 device: ', this.devices[0].label);
          this.startVideo(this.devices[0].deviceId);
          return;
        } else {
          try {
            this.devices.forEach((item, index) => {
              // console.log(index, this.currentCamera);
              if (index > (this.currentCamera || 0)) {
                // console.log('setting device: ', item.label);
                this.startVideo(item.deviceId)
                this.currentCamera = index;
                throw BreakError;
              }
            });
          } catch (err) {
            if (err !== BreakError) throw err;
          }
        }
      }
    }
  }

  protected startVideo(deviceId?: string) {

    const parent = this;

    const candidate = this.storage.getItem('camera');
    if( ! deviceId && candidate) {
      deviceId = candidate;
    }

    // console.log('startvideo with device id', deviceId);

    navigator.mediaDevices.getUserMedia({
      video: {
        width: 720,
        aspectRatio: 1, //this.config.aspectRatio,
        deviceId: deviceId ? { exact: deviceId } : undefined,
        frameRate: 30,
        facingMode: 'user'
      }, audio: false
    }).then((stream: MediaStream) => {
      // console.log('then ', stream);
      parent.videoContainer = this.document.createElement('video');
      parent.videoContainer.playsInline = true;
      parent.videoContainer.autoplay = true;
      parent.videoContainer.muted = true;
      parent.videoContainer.srcObject = stream;
      parent.state = Lifecycle.CAPTURING;
    })
      .catch((error) => {
        // console.log('catch ', error);
        // console.log('startVideo', error);
        if (error.name == 'NotAllowedError') {
          this.videoAllowed = false;
        }
      });


  }

  protected stopVideo() {
    this.canvas.stopVideo();
  }

  take() {

    const parent = this;

    this.state = Lifecycle.CAPTURING_TRIGGERED;

    this.counter = 3;

    interval(1000).pipe(
      take(3)
    ).subscribe({
      next: () => this.counter = this.counter - 1,
      complete: () => {

        this.canvas.takeSnapshot(this.rotate).then((blob: Blob) => {
          // console.log('blob', blob)
          this.canvas.stopVideo();
          // console.log('image file saved - safe to call process');
          // console.log('about to call process');
          this.images.push(blob);
          // console.log(this.images);
          if (this.images.length < (this.config?.numInputImages || 1)) {
            this.startVideo();
          } else {
            if(this.config.enableTakeAgainButton) {
              this.previewScreen = true;
            } else {
              // console.log('I will upload now', this.images);
              this.upload();
            }

          }
        });

        parent.state = Lifecycle.CAPTURED;
      }
    });
  }

  hasMoreThanOneCamera(): boolean {
    if (this.devices) {
      return this.devices?.length > 1;
    } else return false;
  }

  onFileSelected(event: any) {

    this.images = event.target.files;

    if(this.images.length > 0) {
      this.upload();
    }
  }

  protected upload() {
    const sources$ = [];

    this.state = Lifecycle.CAPTURED_UPLOADING;

    const userConfig = JSON.parse(this.storage.getItem('user_config') || '{}');


    for(let idx in this.images) {
      // console.log(idx, this.images[idx]);
      if(this.images[idx] instanceof File || this.images[idx] instanceof Blob) {
        sources$.push(this.uploadImage(this.images[idx], +idx + 1));
      }
    }

    forkJoin(sources$).pipe(
      // tap(console.log),
      tap(() => this.state = Lifecycle.CAPTURED_PROCESSING),
      mergeMap(() => this.reCaptchaV3Service.execute('createJob')),
      mergeMap((token: string) => this.httpClient.post(environment.api_v2_url + '/jobs', {
        assets: this.filenames.map((file: {filename: string, contentType: string}) => {
          return {
            url: environment.assets_url + 'uploads/' + file.filename,
            contentType: file.contentType
          }
        }),
        event: this.config.id,
        user_config: this.flatten(userConfig)
      }, {
        headers: {
          'X-ReCaptcha-Token': token
        }
      })),
      retry({
        delay: 3000,
        count: 3,
        resetOnSuccess: true
      }),
    ).subscribe({
      next: (data: any) => {
        this.state = Lifecycle.COMPLETED;
        return this.router.navigate([ '../form', data['id'] || '' ], { relativeTo: this.route }).then(() => {
          this.storage.removeItem('user_config');
        });
      },
      error: (error) => {
        if(error.url.endsWith('/jobs')) {
          if(error.status === 500) {
            this.serverError = true;
          }
          if(error.status === 401) {
            this.captchaFailed = true;
          }
        }

        this.state = Lifecycle.ERROR;
      }
    });

  }

  protected uploadImage(image: Blob, order?: number): Observable<any> {

    const payload: any = { contentType: image['type'] }

    if(order) {
      payload['order'] = order;
    }

    return this.httpClient.post<{ url: string, filename: string }>(environment.api_v1_url + '/createPublicUploadUrl', payload).pipe(
      mergeMap((response: { url: string, filename: string }) => this.httpClient.put(response.url, image, { observe: 'response' }).pipe(
        map(resp => {
          return { url: response.url, filename: response.filename, response: resp };
        })
      )),
      tap((result: {url: string, filename: string, response: any}) => {
        // console.log(result);
        this.filenames.push({ filename: result.filename, contentType: image['type'] });
        this.state = Lifecycle.CAPTURED_PROCESSING
      }),
    );
  }

  toUrl(img: Blob) {
    return this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(img));
  }

  accept() {
    this.previewScreen = false;
    this.upload();
  }

  retake(index?: number) {
    // console.log(this.images, index);
    if(index || index === 0) {
        this.images.splice(index, 1);
    }
    else {
      this.images = [];
    }

    // console.log(this.images);

    this.previewScreen = false;
    this.state = Lifecycle.INIT;
    this.startVideo();
  }

  private flatten(userConfig: any) {
    let output: any;
    if(userConfig.hasOwnProperty('<!--(survey)--!>')) {
      output = userConfig['<!--(survey)--!>'];
    }
    else {
      output = {};
    }

    for (let key in userConfig) {
      if(key !== '<!--(survey)--!>') {
        if(userConfig[key] && userConfig[key] !== '') {
          output[key] = userConfig[key];
        }
      }
    }

    return output;
  }
}
